// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAgvkqFY2Vtfj-5WnrPXiYu3jgRph3X5Bs",
  authDomain: "switch-smartly.firebaseapp.com",
  projectId: "switch-smartly",
  storageBucket: "switch-smartly.firebasestorage.app",
  messagingSenderId: "802198745928",
  appId: "1:802198745928:web:edba19e8ecf016050a797d",
  measurementId: "G-92FZHMB5HL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Auth
export const db = getFirestore(app);
export const auth = getAuth(app);

